// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { Card, CardContent, Typography } from '@mui/material';
import { AppIcon } from '@shared/ui-kit/components';
import { Translation } from '@shared/ui-kit/providers';
import { defineComponent } from '@shared/ui-kit/utils/define-component';
import {
  usePrecontractualInfoCard,
  type PrecontractualInfoCardProps,
} from './use-precontractual-info-card';

export const PrecontractualInfoCard = defineComponent<
  'PrecontractualInfoCard',
  PrecontractualInfoCardProps
>({
  displayName: 'PrecontractualInfoCard',
  useSetup: usePrecontractualInfoCard,
  View: ({ advisoryTypeKey }) => {
    return (
      <Card
        variant="outlined"
        className="!rounded-lg"
        data-testid="precontractual-information-card"
      >
        <CardContent className="!p-7">
          <Typography
            variant="h4"
            className="!mb-6"
            data-testid="precontractual-information-title"
          >
            <Translation
              i18nKey={`onboarding-process-overview.result-and-signature.precontractual-information.${advisoryTypeKey}.title`}
              ns="components"
            />
          </Typography>

          <div
            className="mb-6 space-y-4"
            data-testid="precontractual-information-content"
          >
            <Translation
              i18nKey={`onboarding-process-overview.result-and-signature.precontractual-information.${advisoryTypeKey}.content`}
              ns="components"
              components={{
                p: <p className="text-justify text-base leading-6" />,
                strong: <strong className="text-lg font-semibold" />,
                hr: <hr className="my-8 border-gray-300" />,
              }}
              tOptions={{
                interpolation: { escapeValue: false },
              }}
            />
          </div>

          <a
            href="/docs/info-precontractual-asesoramiento.pdf"
            download
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-secondary hover:text-secondary/75"
            data-testid="precontractual-information-pdf-link"
          >
            <AppIcon icon="FileText" size="base" />
            <Translation
              i18nKey={`onboarding-process-overview.result-and-signature.precontractual-information.${advisoryTypeKey}.pdf-link`}
              ns="components"
            />
          </a>
        </CardContent>
      </Card>
    );
  },
});
